import { render } from "./SiteFooterExpandLabel.vue?vue&type=template&id=6e0e4a70"
import script from "./SiteFooterExpandLabel.vue?vue&type=script&lang=js"
export * from "./SiteFooterExpandLabel.vue?vue&type=script&lang=js"

import "./SiteFooterExpandLabel.vue?vue&type=style&index=0&id=6e0e4a70&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__